const { Core, Events, Utils } = Global;
const { $state } = Utils;
const PREFIX_BUY_WITH = 'buy_with_' 

customElements.define('product-form', class extends Core {
    propTypes = {
        'multiple-products': Boolean
    }

    elements = {
        toCartButton: 'product-to-cart',
        form: '[data-type=add-to-cart-form]'
    }

    render() {
        this.$('form', {
            submit: this._submitHandler
        });
    }

    _submitHandler(e) {
        e.preventDefault();
        this._validateForm();
        this.prop('multiple-products')
            ? this.$('toCartButton').addToCart(this.cartItems)
            : this.pub(Events.PRODUCT_FORM_SUBMIT, {
                formData: this.formData
              });

    }
    // To prevent send empty form fields
    _validateForm() {
        this.formData = this._getFormData();

        for (const [key, value] of [...this.formData.entries()]) {
            if (value.trim() === "") this.formData.delete(key);
        }
    }

    _isVariantInput([ inputName ]) {
        return inputName.includes(PREFIX_BUY_WITH) || inputName === 'id';
    }

    _setCartItem([ _, value ]) {
        return {
            id: value,
            quantity: 1
        }
    }

    _getFormData() {
        return new FormData(this.$('form'));
    }

    get cartItems() {
        return Array.from(this.formData.entries())
            .filter(this._isVariantInput.bind(this))
            .map(this._setCartItem.bind(this))
    }
})

document.addEventListener('DOMContentLoaded', function () {
  const ADDON_VARIANT_ID = 52566190719144;

  const variantMetaScript = document.querySelector('[id^="variant-metafields-"]');
  if (!variantMetaScript) return;

  const variantMeta = JSON.parse(variantMetaScript.textContent);

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
  }

  async function addAddonItem() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        quantity: 1,
        id: ADDON_VARIANT_ID,
      }),
    });
  }

  document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault(); // Verhindert normales Absenden

      const formData = new FormData(form);
      const selectedVariantId = formData.get('id');
      const isVariantB = variantMeta[selectedVariantId]?.is_variant_b === true;

      // Hauptartikel hinzufügen
      const response = await addToCart(formData);
      if (!response.ok) return;

      // Wenn es eine B-Variante ist → prüfe, ob Zusatzartikel bereits im Warenkorb ist
      if (isVariantB) {
        const cart = await getCart();
        const alreadyInCart = cart.items.some(
          (item) => item.variant_id === ADDON_VARIANT_ID
        );

        if (!alreadyInCart) {
          await addAddonItem();
        }
      }

      // 🛒 Mini-Cart öffnen oder Anzeige aktualisieren
      // Beispiel: Trigger für Mini-Cart aktualisieren (falls dein Theme das kann)
      const event = new Event('cart:refresh');
      document.dispatchEvent(event);
    });
  });
});
